import React, { useState } from "react";
import { X } from "lucide-react";

export default function SiteFooter() {
  const [showPrivacy, setShowPrivacy] = useState(false);

  return (
    <footer className="mt-10 px-4 sm:px-6 py-4 text-center" data-testid="site-footer">
      <p className="osrs-shadow text-[11px] leading-relaxed text-[#b9a06a] max-w-3xl mx-auto">
        TaskScape is a fan-made project and is <strong>not affiliated with, endorsed by, or associated with Jagex Ltd</strong>.
        RuneScape and Old School RuneScape are trademarks of Jagex Ltd.
        <button
          data-testid="open-privacy"
          onClick={() => setShowPrivacy(true)}
          className="ml-2 underline text-[#E6A519] hover:text-[#FFCF3F] transition-colors"
        >
          Privacy
        </button>
      </p>

      {showPrivacy && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 px-4" onClick={() => setShowPrivacy(false)}>
          <div className="osrs-panel p-6 w-full max-w-md text-left" onClick={(e) => e.stopPropagation()} data-testid="privacy-modal">
            <div className="flex items-center justify-between mb-3">
              <h3 className="osrs-title text-xl">Privacy</h3>
              <button onClick={() => setShowPrivacy(false)} className="osrs-btn px-2 py-1" data-testid="close-privacy"><X size={16} /></button>
            </div>
            <div className="osrs-shadow text-[#E6A519] text-sm space-y-2 leading-relaxed">
              <p>We store only what's needed to run TaskScape:</p>
              <ul className="list-disc pl-5 space-y-1 text-[#d8c188]">
                <li>Your email and display name (for your account login).</li>
                <li>The public OSRS usernames you choose to track and their public hiscores data.</li>
                <li>Your task progress, points and streaks.</li>
              </ul>
              <p>We read <strong>public</strong> data from the OSRS Hiscores, Wise Old Man, TempleOSRS and WikiSync. We never log into or post to your RuneScape account, and we never ask for your game password.</p>
              <p>We don't sell your data. You can remove any tracked account at any time, which deletes its data.</p>
            </div>
          </div>
        </div>
      )}
    </footer>
  );
}
